import { BaseRepository } from '../../infra/base.repository'
import { ConfigService } from '../../infra/config'
import type { Entry } from './entry'

export class EntriesRepository extends BaseRepository<Entry> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.financialApiUrl + '/entries', token, cache)
    }

    async upsert(dto: Partial<Entry>) {
        const { json, statusCode, message } = await this.request.post(this.config.financialApiUrl + '/entries/?token=' + this.resolvedToken, dto)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async bulkUpsert(dto: Partial<Entry>[]) {
        const { json, statusCode, message } = await this.request.post(
            this.config.financialApiUrl + '/entries/bulk?token=' + this.resolvedToken,
            dto,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getEntriesByCategoryAndCash(from: Date, to: Date, pos: boolean = false) {
        const { json, statusCode, message } = await this.request.get(
            this.config.financialApiUrl +
                '/entries/category/cash?from=' +
                from +
                '&to=' +
                to +
                (pos ? '&source=pos' : '') +
                '&token=' +
                this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async getEntriesByCategoryAndAccrual(from: Date, to: Date, pos: boolean = false) {
        const { json, statusCode, message } = await this.request.get(
            this.config.financialApiUrl +
                '/entries/category/accrual?from=' +
                from +
                '&to=' +
                to +
                (pos ? '&source=pos' : '') +
                '&token=' +
                this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
